export default {
  header: {
    title: 'All Dispatches',
    newDispatch: 'New Dispatch',
    dashboard: 'Dashboard',
    management: 'Management',
    dispatches: 'Dispatches',
    clock: {
      usButton: 'US',
      mexicoButton: 'Mexico',
      canadaButton: 'Canada',
      yourTimeZone: 'Your Time Zone',
      pacific: 'Pacific',
      mountain: 'Mountain',
      central: 'Central',
      eastern: 'Eastern',
      arizona: 'Arizona',
      alaska: 'Alaska',
      hawaii: 'Hawaii',
      atlantic: 'Atlantic',
      newfoundland: 'Newfoundland'
    }
  },
  filters: {
    searchDispatches: 'Search dispatches',
    sortBy: 'Sort By',
    clients: 'Clients',
    lastUpdateNewest: 'Last update (newest first)',
    lastUpdateOldest: 'Last update (oldest first)',
    openOnly: 'Open Only',
    dispatchStatus: 'Dispatch Status',
    dispatchState: 'Dispatch State',
    type: 'Type',
    noAssignedProvider: 'No Assigned Provider',
    refreshDispatchList: 'Refresh Dispatch List',
    approachingETA: 'Approaching ETA',
    late: 'Late',
    onTime: 'On Time',
    needsApproval: 'Needs Approval',
    needsCancelApproval: 'Needs Cancel Approval',
    statuses: {
      Accepted: 'Accepted',
      'In Route': 'In Route',
      'On Scene': 'On Scene',
      'Tow In Progress': 'Tow In Progress',
      'Destination Arrival': 'Destination Arrival',
      Complete: 'Complete',
      New: 'New',
      Cancelled: 'Cancelled',
      GOA: 'GOA'
    },
    states: {
      'Provider on the way': 'Provider on the way',
      'Provider on site': 'Provider on site',
      'Provider at Drop off': 'Provider at Drop off',
      'Provider En-route to Drop off': 'Provider En-route to Drop off',
      'Provider Completed': 'Provider Completed',
      'Provider Accepted': 'Provider Accepted',
      'Dispatch created': 'Dispatch created',
      'Driver Assigned': 'Driver Assigned',
      'Provider Cancelled': 'Provider Cancelled',
      'Customer Cancelled': 'Customer Cancelled',
      'Customer or vehicle not at Pick Up': 'Customer or vehicle not at Pick Up',
      'Provider Cancelled - DO NOT RE-DISPATCH': 'Provider Cancelled - DO NOT RE-DISPATCH',
      'Searching For Providers': 'Searching For Providers',
      'Processing Auto Dispatch': 'Processing Auto Dispatch',
      'Awaiting Manual Dispatch': 'Awaiting Manual Dispatch',
    },
    types: {
      all: 'All',
      onDemand: 'On Demand',
      scheduled: 'Scheduled',
      approvalRequired: 'Approval Required',
      outOfNetwork: 'Out Of Network',
      secondary: 'Secondary',
    }
  },
  grid: {
    columns: {
      dispatchCustomer: 'Dispatch / Customer',
      dispatchDate: 'Dispatch Date',
      service: 'Service',
      locations: 'Locations',
      providerDriver: 'Provider',
      actions: 'Actions',
      clientNameAndDispatchId: 'Client / Dispatch ID',
      motoristNameAndPhone: 'Motorist Name / Phone',
      // TODO: Unsure if this is dateCreated or clientPickupTime
      createdAndScheduled: 'Created / Scheduled',
      eta: 'ETA / Assigned',
      timeStatus: 'Time Status',
      serviceType: 'Service Type',
      statusState: 'Status / State',
      csrAssigned: 'CSR Assigned',
      providerAssigned: 'Provider Assigned',
      callDetails: 'Call Details',
    }
  }
};
